import { useEffect, useRef, useState } from "@lukekaalim/act"
import { ClientData, ID, Logger, Map2D, useJeffect, useLogger } from "@kosmod/kit"
import { Logic, Mini, TerrainCanvas, TerrainChunk } from "../defs"
import { Observable } from "rxjs"
import { createSpace2DFromChunkMap, Space2DInterface } from "../lib/space"

import * as three from 'three';
import { CanvasCoordinator, ChunkAction, ChunkKey, ChunkMap, createChunkMap, ReadonlyChunkMap, Set2D } from "@kosmod/stew"
import { TerrainSystemData } from "../components/TerrainSystems/terrain"
import { calculateMiniAnimationPoint } from "../components"

/**
 * Visibility:
 *  0 - darkness
 *  255 - @ visibility source
 */

/**
 * 
 * @param interior Positive numbers are visibility-conductive
 * @param minis For finding Doors and Walls
 * @param onChunksChange 
 */
// export const useVisibilityMap = (
//   interior: ReadonlyChunkMap<null | TerrainSystemData>,
//   miniClients: ClientData<Mini>[],
//   coordinator: CanvasCoordinator,
// ) => {
//   const visibilityMap = useRef(createChunkMap(ID('terrain_canvas', 'visibility'), () => 0)).get();
//   const logger = useLogger('VisiblyMapGen');

//   const calculateVisibility = () => {

//     const prevChunks = new Set2D([...visibilityMap.chunks.keys()])

//     visibilityMap.chunks.clear();
//     logger.log(`Rebuilding all visibility chunks`);

//     const minis = miniClients
//       .map(m => m.current);

//     const doorPositionList = minis
//       .filter(m => m.logic.some(l => l.key === 'door' && !l.data.open))
//       .map(m => [m.position.vector.x, m.position.vector.y, m] as const)

//     logger.log(`Active Doors`, { doorPositionList, minis: miniClients.map(m => m.current.logic.map(l => [m.current.id, l.key, { ...l.data }])) });

//     const doorMap = new Map2D(doorPositionList)

//     const calcVisibilitySource = (mini: Mini): [visLevel: number, position: three.Vector2][] => {
//       if (!mini.logic.some(l => l.key === 'visibility-source' && l.enabled))
//         return [];

//       if (mini.animation) {
//         const now = performance.now();
//         const positionIndex = Math.round((now - mini.animation.start) / 400);
//         if (positionIndex >= 0 && positionIndex < mini.animation.points.length) {
//           const position = mini.animation.points[positionIndex]
//           return [
//             [255, new three.Vector2(position.vector.x, position.vector.y)]
//           ]
//         }
//       }
//       return [
//         [255, new three.Vector2(mini.position.vector.x, mini.position.vector.y)]
//       ]
//     }

//     const queue = minis
//       .flatMap(calcVisibilitySource);

//     const visited = new Map2D<number, number, number>();

//     while (queue.length > 0) {
//       const [visLevel, position] = queue.pop()!;

//       if ((visited.getOrNull(position.x, position.y) || 0) >= visLevel)
//         continue;
//       visited.set(position.x, position.y, visLevel);


//       const int = interior.read(position.x, position.y);
//       if (int === null || int.floor === null)
//         continue;

//       // very visible
//       visibilityMap.write(position.x, position.y, visLevel);

//       let nextVisLevel = (visLevel < 255 && visLevel > 0) ? visLevel - 50 : visLevel;

//       if (doorMap.has(position.x, position.y)) {
//         nextVisLevel = visLevel - 50;
//       }

//       // add neighbours
//       if (!int.walls[1])
//         queue.push([nextVisLevel, new three.Vector2(position.x + 1, position.y)]);
//       if (!int.walls[3])
//         queue.push([nextVisLevel, new three.Vector2(position.x - 1, position.y)]);
//       if (!int.walls[2])
//         queue.push([nextVisLevel, new three.Vector2(position.x, position.y + 1)]);
//       if (!int.walls[0])
//         queue.push([nextVisLevel, new three.Vector2(position.x, position.y - 1)]);
//     }
      
//     const newChunks = [...visibilityMap.chunks.keys()]
//     for (const [x, y] of newChunks) {
//       prevChunks.delete(x, y);
//       coordinator.queue([[visibilityMap.canvasId, x, y], 'update'])
//     }
//     for (const [x, y] of prevChunks.keys()) {
//       coordinator.queue([[visibilityMap.canvasId, x, y], 'remove'])
//     }
//     coordinator.run()
//   };

//   useJeffect((j) => {
    
//     j.add(coordinator.updates.subscribe(chunks => {
//       if (chunks.some(([[c, x, y], a]) => c === interior.canvasId && visibilityMap.chunks.has(x, y))) {
//         calculateVisibility();
//       }
//     }))
    
//   }, [interior, coordinator, miniClients])

//   useJeffect((j) => {
//     calculateVisibility()

//     const onMiniChange = (mini: Mini) => {
//       if (mini.animation) {
//         const id = setInterval(() => {
//           if (!mini.animation || mini.animation.start + (mini.animation.points.length * 400) < performance.now()) {
//             clearInterval(id);
//             return;
//           }
//           calculateVisibility();
//         }, 200)
//       } else {
//         calculateVisibility();
//       }
//     }

//     for (const mini of miniClients) {
//       j.add(mini.change.subscribe(onMiniChange))
//     }
//   }, [miniClients])

//   return visibilityMap;
// }


export const recalculateAllVisibility = (
  terrainMap: ReadonlyChunkMap<TerrainSystemData | null>,
  visibilityMap: ChunkMap<number>,

  minis: Mini[],

  logger: Logger,
): [ChunkKey, ChunkAction][] => {
  const prevChunks = new Set2D([...visibilityMap.chunks.keys()])

  // delete all previous visibility
  visibilityMap.chunks.clear();

  const doorMap = new Set2D()
  const queue: [strength: number, position: three.Vector2][] = [];
  const visited = new Map2D<number, number, number>();

  const now = Date.now();

  const calcMiniPosition = (mini: Mini) => {
    const [, animatedPosition] = calculateMiniAnimationPoint(mini.position, mini.animation, now)
    return animatedPosition;
  }

  // setup queue and obstacles
  for (const mini of minis) {
    const position = calcMiniPosition(mini);

    const door = Logic.find('door', mini.logic);
    const visSource = Logic.find('visibility-source', mini.logic);
    
    if (door && !door.data.open)
      doorMap.add(position.vector.x, position.vector.y);

    if (visSource)
      queue.push([visSource.data.strength, new three.Vector2(position.vector.x, position.vector.y)])
  }

  // logger.log([...queue], doorMap)

  while (queue.length > 0) {
    const [visLevel, position] = queue.shift()!;

    if ((visited.getOrNull(position.x, position.y) || 0) >= visLevel)
      continue;

    visited.set(position.x, position.y, visLevel);

    const int = terrainMap.read(position.x, position.y);
    if (int === null || int.floor === null)
      continue;

    // very visible
    visibilityMap.write(position.x, position.y, visLevel);

    let nextVisLevel = (visLevel < 255 && visLevel > 0) ? visLevel - 1 : visLevel;

    if (doorMap.has(position.x, position.y)) {
      nextVisLevel = Math.min(nextVisLevel, 3);
    }

    if (nextVisLevel < 1)
      continue;
    
    // add neighbours
    if (!int.walls[0])
      queue.push([nextVisLevel, new three.Vector2(position.x, position.y - 1)]);
    if (!int.walls[1])
      queue.push([nextVisLevel, new three.Vector2(position.x + 1, position.y)]);
    if (!int.walls[3])
      queue.push([nextVisLevel, new three.Vector2(position.x - 1, position.y)]);
    if (!int.walls[2])
      queue.push([nextVisLevel, new three.Vector2(position.x, position.y + 1)]);
  }
    
  const newChunks = [...visibilityMap.chunks.keys()]
  const actions: [ChunkKey, ChunkAction][] = [];

  for (const [x, y] of newChunks) {
    prevChunks.delete(x, y);
    actions.push([[visibilityMap.canvasId, x, y], 'update'])
    // coordinator.queue([[visibilityMap.canvasId, x, y], 'update'])
  }
  for (const [x, y] of prevChunks.keys()) {
    actions.push([[visibilityMap.canvasId, x, y], 'remove'])
    // coordinator.queue([[visibilityMap.canvasId, x, y], 'remove'])
  }
  
  return actions;
}